import React from 'react';
import PropTypes from 'prop-types';

import HorizontalForm from 'components/form/horizontal_form';

export default class ContactFields extends React.Component {
  static propTypes = {
    contact: PropTypes.shape({
      companyName: PropTypes.string,
      email: PropTypes.string,
      firstName: PropTypes.string,
      jobTitle: PropTypes.string,
      lastName: PropTypes.string,
      mobilePhoneNumber: PropTypes.string,
      officePhoneNumber: PropTypes.string
    }),
    showCompanyName: PropTypes.bool,
    onChange: PropTypes.func.isRequired
  };

  handleChange = (e) => {
    const { name } = e.target;
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;

    this.props.onChange({ ...this.props.contact, [name]: value });
  }

  render() {
    return (
      <HorizontalForm>
        <HorizontalForm.TextInput
          name="firstName"
          value={this.props.contact.firstName}
          onChange={this.handleChange}
        />

        <HorizontalForm.TextInput
          name="lastName"
          value={this.props.contact.lastName}
          onChange={this.handleChange}
        />

        <HorizontalForm.TextInput
          name="email"
          value={this.props.contact.email}
          onChange={this.handleChange}
        />

        <HorizontalForm.TextInput
          name="mobilePhoneNumber"
          value={this.props.contact.mobilePhoneNumber}
          onChange={this.handleChange}
        />

        <HorizontalForm.TextInput
          label="Work Phone Number"
          name="officePhoneNumber"
          value={this.props.contact.officePhoneNumber || ''}
          onChange={this.handleChange}
        />

        <HorizontalForm.TextInput
          name="jobTitle"
          value={this.props.contact.jobTitle || ''}
          onChange={this.handleChange}
        />

        {this.props.showCompanyName &&
          <HorizontalForm.TextInput
            name="companyName"
            value={this.props.contact.companyName || ''}
            onChange={this.handleChange}
          />
        }
      </HorizontalForm>
    );
  }
}
